// extracted by mini-css-extract-plugin
export default {"syncIcon":"syncButton_syncIcon__eESt6","syncButton":"syncButton_syncButton__DRTqI"};